import { gsap, ScrollTrigger } from "./globals.js";
document.addEventListener("DOMContentLoaded", () => {
	// PARALLAX IMAGE
	const parallaxWrap = document.querySelector(".parallax-image");

	if (parallaxWrap) {
	  gsap.registerPlugin(ScrollTrigger);

	  ScrollTrigger.create({
	    trigger: parallaxWrap,
	    start: "top top",
	    end: "bottom top",
	    onEnter: () => parallaxWrap.classList.add("unfixed"),
	    onLeaveBack: () => parallaxWrap.classList.remove("unfixed"),
	    // optional: prevent toggleClass from interfering
	    toggleClass: null,
	  });
	}
});
